import { Link } from "react-router-dom";
import { useState } from "react";
import { ArrowLeft, Mail, CheckCircle2 } from "lucide-react";
import { AccessBranding } from "@/components/AccessBranding";
import { BackLink } from "@/components/BackLink";
import { supabase } from "@/integrations/supabase/client";
import { customerUrl } from "@/lib/public-urls";
import { translateAuthError } from "@/lib/auth-errors";

function ForgotPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    if (!email) { setError("Ange e-postadress"); return; }
    setError(""); setBusy(true);
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: customerUrl("/access/reset-password"),
    });
    setBusy(false);
    if (error) { setError(translateAuthError(error.message)); return; }
    setSent(true);
  }

  return (
    <div className="min-h-screen bg-[var(--color-ink)] flex items-center justify-center px-6 py-10">
      <div className="w-full max-w-md">
        <div className="mb-4"><BackLink fallback="/access/login" /></div>
        <div className="text-center mb-8"><AccessBranding /></div>
        <div className="card-soft p-8">
          {!sent ? (
            <>
              <h1 className="!text-2xl text-center mb-2">Glömt lösenord?</h1>
              <p className="text-center text-muted-foreground text-sm mb-6">Ange din e-post så skickar vi en återställningslänk.</p>
              <form onSubmit={submit}>
                <label className="label-field">E-postadress</label>
                <input className={`input-field ${error ? "input-error" : ""}`} placeholder="namn@exempel.se" value={email} onChange={e => setEmail(e.target.value)} />
                {error && <p className="text-destructive text-xs mt-1">{error}</p>}
                <button type="submit" disabled={busy} className="btn-pill w-full mt-6">{busy ? "Skickar…" : "Skicka återställningslänk"}</button>
              </form>
            </>
          ) : (
            <div className="text-center">
              <div className="w-16 h-16 mx-auto rounded-full bg-success/10 flex items-center justify-center mb-4">
                <CheckCircle2 className="text-[var(--color-success)]" size={32} />
              </div>
              <h2 className="!text-xl mb-2">Kolla din e-post</h2>
              <p className="text-muted-foreground text-sm flex items-center justify-center gap-2">
                <Mail size={16} /> Vi har skickat en länk till <strong className="text-foreground">{email}</strong>
              </p>
            </div>
          )}
          <Link to="/access/login" className="mt-6 inline-flex items-center gap-2 text-sm text-primary hover:underline">
            <ArrowLeft size={14} /> Tillbaka till inloggning
          </Link>
        </div>
      </div>
    </div>
  );
}

export default ForgotPage;
